import BluebirdPromise from 'bluebird';

BluebirdPromise.config({
  cancellation: true,
  warnings: false,
});

export function makeCancelable<T>(promise: Promise<T>): BluebirdPromise<T> {
  return new BluebirdPromise<T>((resolve, reject, onCancel) => {
    promise.then(resolve).catch(reject);
    onCancel(() => {});
  });
}
